<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12 ">
        <div class="card h-100 mt-3">
          <div class="card-header mb-0">
            <div class="row no-gutters">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <h5>{{ $t('content.maddress') }}</h5>
                <div>
                  <material-button color="primary" class="float-lg-start float-sm-end mb-0" @click="addNewItems">
                    <i class="material-icons material-symbols-outlined">add</i> {{ btnAddNew }}
                  </material-button>
                </div>
              </div>
            </div>

          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="table-responsive">
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th style="width: 70px;">#</th>
                      <th>{{ $t('content.add1') }}</th>
                      <th>{{ $t('content.add2') }}</th>
                      <th>{{ $t('content.add3') }}</th>
                      <th>{{ $t('content.add4') }}</th>
                      <th style="width: 100px;">{{ $t('content.act') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="group-id-ticket">
                      <td class="text-sm font-weight-normal">
                        <div class="group-tickect">
                          <h6 class="mb-0"><b>{{ btnSearch }}</b></h6>
                        </div>
                      </td>
                      <td class="text-sm font-weight-normal">
                        <div class="input-group">
                          <input v-model="datas.coreBox1" type="text" class="form-control">
                          <button class="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                          </button>
                          <ul class="dropdown-menu dropdown-menu-end">
                            <li>
                              <div class="input-group">
                                <input type="text" class="form-control mb-0" placeholder="ค้นหา" />
                              </div>
                            </li>
                            <li>
                              <hr class="dropdown-divider">
                            </li>
                            <li v-for="(a, corea) in datas.demo1" :key="corea"><a class="dropdown-item"
                                href="#"><material-checkbox class="check-inline" checked="false" /> {{
                                  a.items }}</a></li>
                          </ul>
                        </div>
                      </td>
                      <td class="text-sm font-weight-normal">
                        <div class="input-group">
                          <input v-model="datas.coreBox2" type="text" class="form-control">
                          <button class="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                          </button>
                          <ul class="dropdown-menu dropdown-menu-end">
                            <li>
                              <div class="input-group">
                                <input type="text" class="form-control mb-0" placeholder="ค้นหา" />
                              </div>
                            </li>
                            <li>
                              <hr class="dropdown-divider">
                            </li>
                            <li v-for="(b, coreb) in datas.demo2" :key="coreb"><a class="dropdown-item"
                                href="#"><material-checkbox class="check-inline" checked="false" /> {{
                                  b.items }}</a></li>
                          </ul>
                        </div>
                      </td>
                      <td class="text-sm font-weight-normal">
                        <div class="input-group">
                          <input v-model="datas.coreBox3" type="text" class="form-control">
                          <button class="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                          </button>
                          <ul class="dropdown-menu dropdown-menu-end">
                            <li>
                              <div class="input-group">
                                <input type="text" class="form-control mb-0" placeholder="ค้นหา" />
                              </div>
                            </li>
                            <li>
                              <hr class="dropdown-divider">
                            </li>
                            <li v-for="(c, corec) in datas.demo3" :key="corec"><a class="dropdown-item"
                                href="#"><material-checkbox class="check-inline" checked="false" /> {{
                                  c.items }}</a></li>
                          </ul>
                        </div>
                      </td>
                      <td class="text-sm font-weight-normal">
                        <div class="input-group">
                          <input v-model="datas.coreBox4" type="text" class="form-control">
                          <button class="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                          </button>
                          <ul class="dropdown-menu dropdown-menu-end">
                            <li>
                              <div class="input-group">
                                <input type="text" class="form-control mb-0" placeholder="ค้นหา" />
                              </div>
                            </li>
                            <li>
                              <hr class="dropdown-divider">
                            </li>
                            <li v-for="(d, cored) in datas.demo4" :key="cored"><a class="dropdown-item"
                                href="#"><material-checkbox class="check-inline" checked="false" /> {{
                                  d.items }}</a></li>
                          </ul>
                        </div>
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch">
                          <i class="material-icons material-symbols-outlined">search</i>
                        </material-button>
                        <material-button v-if="datas.addNew" color="info" variant="contain" class="rounded-circle"
                          data-bs-toggle="tooltip" data-bs-placement="top" title="คัดลอกข้อมูล"
                          :disabled="checkBeforeCopy(datas.coreCopy)">
                          <i class="material-icons material-symbols-outlined">content_copy</i>
                        </material-button>
                      </td>
                    </tr>

                    <tr v-if="datas.addNew">
                      <td class="text-sm font-weight-normal">#</td>
                      <td class="text-sm font-weight-normal"><material-input type="text" class="mb-0" value="" /></td>
                      <td class="text-sm font-weight-normal"><material-input type="text" class="mb-0" value="" /></td>
                      <td class="text-sm font-weight-normal"><material-input type="text" class="mb-0" value="" /></td>
                      <td class="text-sm font-weight-normal"><material-input type="text" class="mb-0" value="" /></td>
                      <td class="text-sm font-weight-normal">
                        <material-button color="primary" variant="outline" class="rounded-circle" data-bs-toggle="tooltip"
                          data-bs-placement="top" :title="btnSave" @click="saveNewItems">
                          <i class="material-icons material-symbols-outlined">save</i>
                        </material-button>
                        <material-button color="danger" variant="outline" class="rounded-circle" data-bs-toggle="tooltip"
                          data-bs-placement="top" :title="btnClose" @click="cancelSaveNewItems">
                          <i class="material-icons material-symbols-outlined">close</i>
                        </material-button>
                      </td>
                    </tr>

                    <tr v-if="datas.rowEdit">
                      <td class="text-sm font-weight-normal">1</td>
                      <td class="text-sm font-weight-normal"><material-input type="text" class="mb-0" value="xxxxx" />
                      </td>
                      <td class="text-sm font-weight-normal"><material-input type="text" class="mb-0" value="xxxxx" />
                      </td>
                      <td class="text-sm font-weight-normal"><material-input type="text" class="mb-0" value="xxxxx" />
                      </td>
                      <td class="text-sm font-weight-normal"><material-input type="text" class="mb-0" value="xxxxx" />
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-button color="primary" variant="outline" class="rounded-circle" data-bs-toggle="tooltip"
                          data-bs-placement="top" :title="btnSave" @click="saveEditRowItems">
                          <i class="material-icons material-symbols-outlined">save</i>
                        </material-button>
                        <material-button color="danger" variant="outline" class="rounded-circle" data-bs-toggle="tooltip"
                          data-bs-placement="top" :title="btnClose" @click="cancelEditRowItems">
                          <i class="material-icons material-symbols-outlined">close</i>
                        </material-button>
                      </td>
                    </tr>
                    <tr v-else-if="!datas.rowEdit">
                      <td class="text-sm font-weight-normal">1</td>
                      <td class="text-sm font-weight-normal">xxxxx</td>
                      <td class="text-sm font-weight-normal">xxxxx</td>
                      <td class="text-sm font-weight-normal">xxxxx</td>
                      <td class="text-sm font-weight-normal">xxxxx</td>
                      <td class="text-sm font-weight-normal">
                        <material-button color="info" variant="outline" class="rounded-circle" data-bs-toggle="tooltip"
                          data-bs-placement="top" :title="btnEdit" @click="editRowItems">
                          <i class="material-icons material-symbols-outlined">edit</i>
                        </material-button>
                        <material-button color="danger" variant="outline" class="rounded-circle" data-bs-toggle="tooltip"
                          data-bs-placement="top" :title="btnDel">
                          <i class="material-icons material-symbols-outlined">delete</i>
                        </material-button>
                      </td>
                    </tr>

                    <tr>
                      <td class="text-sm font-weight-normal">2</td>
                      <td class="text-sm font-weight-normal">xxxxx</td>
                      <td class="text-sm font-weight-normal">xxxxx</td>
                      <td class="text-sm font-weight-normal">xxxxx</td>
                      <td class="text-sm font-weight-normal">xxxxx</td>
                      <td class="text-sm font-weight-normal">
                        <material-button color="info" variant="outline" class="rounded-circle" data-bs-toggle="tooltip"
                          data-bs-placement="top" :title="btnEdit">
                          <i class="material-icons material-symbols-outlined">edit</i>
                        </material-button>
                        <material-button color="danger" variant="outline" class="rounded-circle" data-bs-toggle="tooltip"
                          data-bs-placement="top" :title="btnDel">
                          <i class="material-icons material-symbols-outlined">delete</i>
                        </material-button>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
              <nav class="mt-3" aria-label="Table Paginator">
                <ul class="pagination justify-content-end">
                  <li class="page-item disabled">
                    <a class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li class="page-item"><a class="page-link" href="#">1</a></li>
                  <li class="page-item"><a class="page-link" href="#">2</a></li>
                  <li class="page-item"><a class="page-link" href="#">3</a></li>
                  <li class="page-item">
                    <a class="page-link" href="#" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
            
<script setup>
import { reactive, inject, computed } from 'vue'
import { useI18n } from "vue-i18n"

import MaterialButton from "@/components/MaterialButton.vue"
import MaterialInput from "@/components/MaterialInput.vue"
// import MaterialRadio from "@/components/MaterialRadio.vue"
// import MaterialCheckbox from "@/components/MaterialCheckbox.vue"

// import logo from "@/assets/img/pawn/logo_buddy.png"

const { t } = useI18n()
const swal = inject('$swal')

const datas = reactive({
  addNew: false,
  rowEdit: false,
  coreCopy: true,
  coreBox1: "",
  coreBox2: "",
  coreBox3: "",
  coreBox4: "",
  demo1: [
    { items: "ประเทศ1" },
    { items: "ประเทศ2" },
    { items: "ประเทศ3" },
    { items: "ประเทศ4" },
    { items: "ประเทศ5" },
    { items: "ประเทศ6" }
  ],
  demo2: [
    { items: "จังหวัด1" },
    { items: "จังหวัด2" },
    { items: "จังหวัด3" },
    { items: "จังหวัด4" },
    { items: "จังหวัด5" },
    { items: "จังหวัด6" }
  ],
  demo3: [
    { items: "อำเภอ1" },
    { items: "อำเภอ2" },
    { items: "อำเภอ3" },
    { items: "อำเภอ4" },
    { items: "อำเภอ5" },
    { items: "อำเภอ6" }
  ],
  demo4: [
    { items: "ตำบล1" },
    { items: "ตำบล2" },
    { items: "ตำบล3" },
    { items: "ตำบล4" },
    { items: "ตำบล5" },
    { items: "ตำบล6" }
  ],
})

const btnAddNew = computed(() => t("buttons.impo"))
const btnEdit = computed(() => t("buttons.edit"))
const btnSearch = computed(() => t("buttons.sear"))
const btnSave = computed(() => t("buttons.save"))
// const btnCancel = computed(() => t("buttons.canc"))
const btnDel = computed(() => t("buttons.remo"))
const btnClose = computed(() => t("buttons.clos"))

const checkBeforeCopy = (bool) => {
  datas.coreCopy = bool
  if (datas.coreBox1 === '') {
    return bool = true
  } else {
    return bool = false
  }
}

async function addNewItems() {
  swal({
    title: "เพิ่มรายการ",
    text: "คุณต้องการเพิ่มรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      datas.addNew = true
    } else if (result.dismiss == 'cancel') {
      swal("ยกเลิกรายการ", "", "error")
      datas.addNew = false
    }
  })
}

async function saveNewItems() {
  swal({
    title: "ต้องการบันทึกรายการนี้",
    text: "คุณต้องการบันทึกรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.save'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      swal("บันทึกสำเร็จ", "", "success")
      datas.addNew = false
    } else if (result.dismiss == 'cancel') {
      swal("ยกเลิกการบันทึก", "", "error")
      datas.addNew = false
    }
  })
}

async function cancelSaveNewItems() {
  swal({
    title: "ยกเลิกบันทึกรายการนี้",
    text: "คุณต้องการยกเลิกบันทึกรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      datas.addNew = false
    } else if (result.dismiss == 'cancel') {
      datas.addNew = true
    }
  })
}

async function editRowItems() {
  swal({
    title: "แก้ไขรายการ",
    text: "คุณต้องการแก้ไขรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      datas.rowEdit = true
    } else if (result.dismiss == 'cancel') {
      swal("ยกเลิกรายการ", "", "error")
      datas.rowEdit = false
    }
  })
}

async function saveEditRowItems() {
  swal({
    title: "บันทึกแก้ไขรายการ",
    text: "คุณต้องการบันทึกแก้ไขรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.save'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      swal("บันทึกสำเร็จ", "", "success")
      datas.rowEdit = false
    } else if (result.dismiss == 'cancel') {
      swal("ยกเลิกแก้ไข", "", "error")
      datas.rowEdit = false
    }
  })
}

async function cancelEditRowItems() {
  swal({
    title: "ยกเลิกแก้ไขรายการ",
    text: "คุณต้องการยกเลิกแก้ไขรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      datas.rowEdit = false
    } else if (result.dismiss == 'cancel') {
      datas.rowEdit = true
    }
  })
}



</script>
            
<style lang="scss" scoped></style>